import { useFormikContext } from "formik";
import { FC, useState } from 'react';
import { DEF_PG_SIZE_SUB } from '../../../../constants/maximum-page-size';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { TableContextProvider } from '../../../../contexts/table/TableContextProvider';
import { getAllAccessGroups } from "../../../../services/accessGroupService";
import AccessGroupColumns from "../../../../models/ColumnDefinitions/AccessGroupColumns";
import { ListQuery } from "../../../../models/ListQuery";
import { Lookup } from "../../../../models/Lookup";
import LookupTypes from "../../../../models/LookupTypes";
import AccessGroupSearch from "../../../../models/search/AccessGroupSearch";
import SiteSearch from "../../../../models/search/SiteSearch";
import { removeColumns } from "../../../../models/utilities/columnHelper";
import { getSiteNamesWithPagination } from "../../../../services/siteService";
import TableTab from "../../../tabs/table-tab";
import { GROUP_TYPE } from "@/constants/area-constants";
import { ACCESS_TYPES } from "@/constants/access-constants";

interface GroupStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
    groupType: GROUP_TYPE // 1 = Access Groups, 2 = Floor Groups
}

const GroupStep: FC<GroupStepProps> = ({ onBack, onNext, setSideBarStepDescription, groupType }) => {
    const { translate } = useLocale();
    const { setFieldValue } = useFormikContext<any>();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const isAccessGroup = groupType == ACCESS_TYPES.ACCESS_GROUP;

    const onLocalNext = (event: any) => {
        setFieldValue(isAccessGroup ? 'accessGroupsIds' : 'floorGroupsIds'  , selectedIds);
        setFieldValue(isAccessGroup ?  'accessGroups' : 'floorGroups', selectedRows);
        setSideBarStepDescription(`${selectedIds.length} ${translate.byKey(TranslationKeys.selected)}`);
        onNext({ ...event });
    };

    const filterToNameAndSiteOnly = searchDescriptor => {
        return searchDescriptor.filter(item => item.accessor === 'name' || item.accessor === 'site');
    };

    const lookup: Lookup[] = [{
        name: LookupTypes.site,
        values: [],
        dataMethod: getSiteNamesWithPagination,
        searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
    }]
    
    return (
        <div className="pt-3 pr-3 pl-3" style={{ height: "90%", overflow: "auto" }}>
            <TableContextProvider
                dataMethod={(listParameters?: ListQuery) => getAllAccessGroups(groupType, translate, listParameters)}
                tableDescriptor={removeColumns(AccessGroupColumns, ['area', 'accessTimePatterns', 'days', 'startTime', 'duration', 'enrolments'])}
                searchDescriptor={filterToNameAndSiteOnly(AccessGroupSearch)}
                useTable
                usePagination
                useSearch
                useSort
                useFilter
                maxPageSize={DEF_PG_SIZE_SUB}
                lookup={lookup}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(isAccessGroup ? TranslationKeys.accessGroups : TranslationKeys.floorGroups)}
                    selectRows={true}
                    selectedIds={selectedIds}
                    selectedRows={selectedRows}
                    setSelectedIds={setSelectedIds}
                    setSelectedRows={setSelectedRows}
                    cyName={isAccessGroup ? "accessGroupStep" : "floorGroupStep"}/>
            </TableContextProvider>

            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                <div className="flex flex-row mt-4">
                    <button
                        className="py-1 px-5 secondary secondary-inverse"
                        type="button"
                        onClick={onBack}
                    >
                        {translate.byKey(TranslationKeys.back)}
                    </button>
                </div>
                <div className="flex flex-row justify-end mt-4 pl-3">
                    <button className={"py-1 px-5 secondary secondary-enabled"}
                        type="button"
                        onClick={(e) => onLocalNext(e)}
                    >
                        {translate.byKey(TranslationKeys.next)}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GroupStep;
